import { Base } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

/**
 * HeroSlider component
 */
export default class HeroSlider extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'HeroSlider',
    refs: ['slider', 'prev', 'next', 'pagination'],
    options: {
      autoplay: {
        type: Boolean,
        default: true,
      },
      delay: {
        type: Number,
        default: 6000,
      },
    },
  };

  /**
   * Mount slider
   */
  mounted() {
    console.log('[HeroSlider] mounted', this.$refs);
    const config = {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 800,
      autoplay: this.$options.autoplay
        ? {
            delay: this.$options.delay,
            disableOnInteraction: false,
          }
        : false,
    };

    if (this.$refs.prev && this.$refs.next) {
      config.navigation = {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      };
    }

    if (this.$refs.pagination) {
      config.pagination = {
        clickable: true,
        el: this.$refs.pagination,
        type: 'bullets',
      };
    }

    this.swiper = new Swiper(this.$refs.slider, config);
  }

  /**
   * Destroy slider on unmount
   */
  destroyed() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}
